import { CONFIG } from '@/configs';
import * as Sentry from '@sentry/react';

export function initializeAnalytics() {
  if (CONFIG.analytics && CONFIG.analytics) {
    Sentry.init({
      dsn: CONFIG.analytics.dsn,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      tracePropagationTargets: CONFIG.analytics.tracePropagationTargets,
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
}
